module.exports = __webpack_public_path__ + "static/video2-f51b02612847a4ef84d0be02734ecf5e.mp4";